module.exports = __webpack_public_path__ + "04_long_brown.80d5c760.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_long_brown.png
// module id = kgO8
// module chunks = 0